(function () {
  'use strict';

  function initFaq(root) {
    if (!root || root.getAttribute('data-loc-ready') === 'faq') return;
    root.setAttribute('data-loc-ready', 'faq');

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-loc-faq-trigger]');
      if (!btn || !root.contains(btn)) return;

      var item = btn.closest('.shh-loc-faq__item');
      if (!item) return;
      var open = item.classList.contains('is-open');

      root.querySelectorAll('.shh-loc-faq__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var b = el.querySelector('[data-loc-faq-trigger]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });

      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function visibleCount(root) {
    var lg = root && root.getAttribute('data-loc-visible-lg');
    var md = root && root.getAttribute('data-loc-visible-md');
    var sm = root && root.getAttribute('data-loc-visible-sm');
    if (window.matchMedia('(min-width: 1024px)').matches) {
      return parseInt(lg || md || '3', 10) || 3;
    }
    if (window.matchMedia('(min-width: 768px)').matches) {
      return parseInt(md || '3', 10) || 3;
    }
    return parseInt(sm || '1', 10) || 1;
  }

  function initCarousel(root) {
    if (!root || root.getAttribute('data-loc-ready') === 'carousel') return;
    root.setAttribute('data-loc-ready', 'carousel');

    var track = root.querySelector('[data-loc-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || slides.length === 0) return;

    var prev = root.querySelector('[data-loc-prev]');
    var next = root.querySelector('[data-loc-next]');
    var dotsWrap = root.querySelector('[data-loc-dots]');
    var index = 0;
    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount(root));
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = maxIndex() + 1;
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'shh-loc-carousel__dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.addEventListener('click', function (iCopy) {
          return function () {
            index = iCopy;
            update();
          };
        }(i));
        dotsWrap.appendChild(dot);
      }
    }

    function update() {
      if (index > maxIndex()) index = maxIndex();
      if (index < 0) index = 0;
      var slideWidth = slides[0].getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var offset = index * (slideWidth + gap);
      track.style.transform = 'translateX(' + -offset + 'px)';
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= maxIndex();
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.shh-loc-carousel__dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        index -= 1;
        update();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        index += 1;
        update();
      });
    }

    track.addEventListener('touchstart', function (event) {
      if (!event.changedTouches[0]) return;
      dragging = true;
      startX = event.changedTouches[0].clientX;
      deltaX = 0;
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      if (!dragging || !event.changedTouches[0]) return;
      deltaX = event.changedTouches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 40) {
        index += deltaX < 0 ? 1 : -1;
        update();
      }
    });

    window.addEventListener('resize', function () {
      renderDots();
      update();
    });

    renderDots();
    update();
  }

  function initSticky() {
    var bar = document.querySelector('[data-loc-sticky]');
    var hero = document.querySelector('[data-loc-hero]');
    var cta = document.querySelector('[data-loc-final-cta]');
    if (!bar || bar.getAttribute('data-loc-ready') === 'sticky') return;
    bar.setAttribute('data-loc-ready', 'sticky');

    var heroGone = false;
    var ctaVisible = false;

    function sync() {
      var show = heroGone && !ctaVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) {
        bar.removeAttribute('inert');
      } else {
        bar.setAttribute('inert', '');
      }
    }

    if ('IntersectionObserver' in window) {
      if (hero) {
        var heroObs = new IntersectionObserver(function (entries) {
          heroGone = entries[0] && !entries[0].isIntersecting;
          sync();
        }, { threshold: 0.15 });
        heroObs.observe(hero);
      } else {
        heroGone = true;
      }

      if (cta) {
        var ctaObs = new IntersectionObserver(function (entries) {
          ctaVisible = entries[0] && entries[0].isIntersecting;
          sync();
        }, { threshold: 0.2 });
        ctaObs.observe(cta);
      }
    } else {
      bar.classList.add('is-visible');
    }
  }

  function parseHm(value) {
    if (!value) return null;
    var parts = String(value).split(':');
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1] || '0', 10);
    if (isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
  }

  function formatHm(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    var suffix = h >= 12 ? 'pm' : 'am';
    var hour12 = h % 12;
    if (hour12 === 0) hour12 = 12;
    if (m === 0) return hour12 + suffix;
    return hour12 + ':' + (m < 10 ? '0' : '') + m + suffix;
  }

  function dallasParts(date, timeZone) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone || 'America/Chicago',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);

    var map = {};
    parts.forEach(function (p) {
      if (p.type !== 'literal') map[p.type] = p.value;
    });

    var weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return {
      day: weekdayMap[map.weekday],
      minutes: parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10)
    };
  }

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function statusFromSchedule(schedule, now) {
    var tz = (schedule && schedule.tz) || 'America/Chicago';
    var days = (schedule && schedule.days) || [];
    var nowParts = dallasParts(now, tz);
    var today = days[nowParts.day];
    var openMin = today ? parseHm(today.open) : null;
    var closeMin = today ? parseHm(today.close) : null;

    if (openMin != null && closeMin != null && nowParts.minutes >= openMin && nowParts.minutes < closeMin) {
      return {
        open: true,
        text: 'Open until ' + formatHm(closeMin)
      };
    }

    // Later today
    if (openMin != null && nowParts.minutes < openMin) {
      return {
        open: false,
        text: 'Opens at ' + formatHm(openMin)
      };
    }

    // Next open day
    for (var offset = 1; offset <= 7; offset++) {
      var dayIndex = (nowParts.day + offset) % 7;
      var slot = days[dayIndex];
      var nextOpen = slot ? parseHm(slot.open) : null;
      if (nextOpen == null) continue;
      return {
        open: false,
        text: 'Opens ' + DAY_NAMES[dayIndex] + ' at ' + formatHm(nextOpen)
      };
    }

    // No open days in the schedule (temporarily closed locations)
    return {
      open: false,
      temporarilyClosed: true,
      text: 'Temporarily Closed'
    };
  }

  function renderHoursStatus(el) {
    var raw = el.getAttribute('data-loc-hours-json');
    if (!raw) return;
    var schedule;
    try {
      schedule = JSON.parse(raw);
    } catch (err) {
      return;
    }

    var status = statusFromSchedule(schedule, new Date());
    if (!status) return;

    el.classList.toggle('is-open', status.open);
    el.classList.toggle('is-closed', !status.open);
    el.classList.toggle('is-temp-closed', !!status.temporarilyClosed);
    var textEl = el.querySelector('[data-loc-hours-text]');
    if (textEl) {
      textEl.textContent = status.text;
    } else {
      el.textContent = status.text;
    }
    el.removeAttribute('hidden');
  }

  function initHoursStatus(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-loc-hours]').forEach(function (el) {
      renderHoursStatus(el);
      if (el.getAttribute('data-loc-hours-timer') === '1') return;
      el.setAttribute('data-loc-hours-timer', '1');
      window.setInterval(function () {
        renderHoursStatus(el);
      }, 60000);
    });
  }

  function initTodayHours(scope) {
    var root = scope || document;
    var table = root.querySelector('[data-loc-hours-table]');
    if (!table) return;
    var rows = table.querySelectorAll('.shh-loc-hours__row--track[data-weekdays]');
    if (!rows.length) return;
    var today = dallasParts(new Date(), 'America/Chicago').day;
    rows.forEach(function (row) {
      var raw = row.getAttribute('data-weekdays');
      if (!raw) return;
      var days = raw.split(',').map(function (value) {
        return parseInt(value, 10);
      });
      if (days.indexOf(today) !== -1) {
        row.classList.add('is-today');
      }
    });
  }

  function initScrollDots(root, opts) {
    if (!root || root.getAttribute(opts.readyAttr) === '1') return;
    root.setAttribute(opts.readyAttr, '1');

    var strip = root.querySelector(opts.stripSel);
    var nav = root.querySelector(opts.navSel);
    var dotsWrap = root.querySelector(opts.dotsSel);
    if (!strip || !nav || !dotsWrap) return;

    var items = Array.prototype.slice.call(strip.querySelectorAll(opts.itemSel));
    if (items.length < 2) return;

    function isScrollable() {
      return strip.scrollWidth > strip.clientWidth + 4;
    }

    function activeIndex() {
      var left = strip.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var dist = Math.abs(items[i].offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function syncDots() {
      var idx = activeIndex();
      var dots = dotsWrap.querySelectorAll('.shh-loc-carousel__dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }

    function renderDots() {
      dotsWrap.innerHTML = '';
      if (!isScrollable()) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      var idx = activeIndex();
      for (var i = 0; i < items.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'shh-loc-carousel__dot' + (i === idx ? ' is-active' : '');
        dot.setAttribute('aria-label', (opts.labelPrefix || 'Go to item ') + (i + 1));
        dot.addEventListener('click', function (iCopy) {
          return function () {
            items[iCopy].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          };
        }(i));
        dotsWrap.appendChild(dot);
      }
    }

    strip.addEventListener('scroll', syncDots, { passive: true });
    window.addEventListener('resize', function () {
      renderDots();
      syncDots();
    });
    renderDots();
    syncDots();
  }

  function initGalleryStrip(root) {
    initScrollDots(root, {
      readyAttr: 'data-loc-strip-ready',
      stripSel: '[data-loc-gallery-strip]',
      navSel: '[data-loc-gallery-nav]',
      dotsSel: '[data-loc-gallery-dots]',
      itemSel: '.shh-loc-gallery__item',
      labelPrefix: 'Go to photo '
    });
  }

  function initMerchStrip(root) {
    initScrollDots(root, {
      readyAttr: 'data-loc-merch-ready',
      stripSel: '[data-loc-merch-strip]',
      navSel: '[data-loc-merch-nav]',
      dotsSel: '[data-loc-merch-dots]',
      itemSel: '.shh-loc-product',
      labelPrefix: 'Go to product '
    });
  }

  function initGallery(root) {
    if (!root || root.getAttribute('data-loc-ready') === 'gallery') return;
    root.setAttribute('data-loc-ready', 'gallery');

    initGalleryStrip(root);

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-loc-gallery-full]'));
    if (!slides.length) return;

    var lightbox = root.querySelector('[data-loc-lightbox]');
    var img = root.querySelector('[data-loc-lightbox-img]');
    var cap = root.querySelector('[data-loc-lightbox-cap]');
    var count = root.querySelector('[data-loc-lightbox-count]');
    var prev = root.querySelector('[data-loc-lightbox-prev]');
    var next = root.querySelector('[data-loc-lightbox-next]');
    if (!lightbox || !img) return;

    var index = 0;
    var lastFocus = null;

    function render() {
      var slide = slides[index];
      if (!slide) return;
      img.src = slide.getAttribute('data-loc-gallery-full') || '';
      img.alt = slide.getAttribute('data-loc-gallery-alt') || '';
      if (cap) cap.textContent = img.alt;
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = slides.length < 2;
      if (next) next.disabled = slides.length < 2;
    }

    function open(at) {
      index = Math.max(0, Math.min(slides.length - 1, at || 0));
      lastFocus = document.activeElement;
      lightbox.hidden = false;
      document.body.classList.add('shh-loc-lightbox-open');
      render();
      var closeBtn = lightbox.querySelector('[data-loc-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.classList.remove('shh-loc-lightbox-open');
      img.removeAttribute('src');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function step(delta) {
      if (slides.length < 2) return;
      index = (index + delta + slides.length) % slides.length;
      render();
    }

    root.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-loc-gallery-open]');
      if (!opener || !root.contains(opener)) return;
      event.preventDefault();
      var at = parseInt(opener.getAttribute('data-loc-gallery-index') || '0', 10);
      open(isNaN(at) ? 0 : at);
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-loc-lightbox-close]')) {
        close();
        return;
      }
      if (event.target.closest('[data-loc-lightbox-prev]')) {
        step(-1);
        return;
      }
      if (event.target.closest('[data-loc-lightbox-next]')) {
        step(1);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-loc-faq]').forEach(initFaq);
    root.querySelectorAll('[data-loc-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-loc-gallery]').forEach(initGallery);
    root.querySelectorAll('.shh-loc-merch').forEach(initMerchStrip);
    initHoursStatus(root);
    initTodayHours(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
